import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { claiminput, EventEmitterBo, functionpermission, IdDatesBO } from "../claims.model";
import { ClaimsService } from "../claims.service";
import { TimesheetVerificatioService } from "../../timesheet-verification/timesheet-verification.service";
import { ToastrService } from "ngx-toastr";
import { ClaimFullBO, ClaimServiceLineBO } from "./cliam-edit.model";
import { CommonHttpService } from "src/app/common.service";
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from "mydatepicker";
import { DateService } from "src/app/date.service";
import { DatePipe } from "@angular/common";
import { GlobalComponent } from "src/app/global/global.component";
import { ClaimEditService } from "./claim-edit.service";
import { PageSettingsModel } from "@syncfusion/ej2-angular-grids";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-claim-edit",
  templateUrl: "./claim-edit.component.html",
  styleUrls: ["./claim-edit.component.scss"],
})
export class ClaimEditComponent implements OnInit {
  public onDestroy$: Subject<void> = new Subject<void>();
  @Input() EditClaim: EventEmitterBo = new EventEmitterBo();
  @Output() EditClaimemit = new EventEmitter<EventEmitterBo>();
  ClaimEditBo: ClaimFullBO = new ClaimFullBO();
  claimServiceLines = []
  AllClientList: any;
  AllEmployeeList: any;
  showEditorView = false;
  genderList: any;
  stateList: any;
  ResubmissionTypeList: any
  public BatchServiceLineList: any
  denialList: any;
  IdDates: IdDatesBO[] = [];
  timesheetVerificationInput: claiminput = new claiminput();
  openverification: boolean = false;
  client_DOB;

  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public formatDateOptions: object;
  public pageSettings: PageSettingsModel;
  public filterSettings: object;
  fp: functionpermission = new functionpermission();

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  };
  IsButtonDisable: boolean = false;
  constructor(
    public claimService: ClaimsService,
    public datepipe: DatePipe,
    public global: GlobalComponent,
    public dateservice: DateService,
    private commonhttp: CommonHttpService,
    public TimesheetVservice: TimesheetVerificatioService,
    public toastservice: ToastrService,
    public claimEditService: ClaimEditService,
    private datePipe: DatePipe,

  ) { }

  ngOnInit(): void {
    this.filterSettings = {
      type: "Menu",
    };
    this.formatDateOptions = { type: "datetime", format: "MM/dd/yyyy" };
    this.pageSettings = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.getClaimEditDetails();
    setTimeout(() => {
      this.getGender();
    }, 1000)
    this.getStateList();
    this.GetResubmissionTypeListLov();
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "CLAIMS");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.claimService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  getStateList() {
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.stateList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  getGender() {
    let params = new URLSearchParams();
    params.append("listCode", "GENDER");
    this.claimService
      .getLovType(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.genderList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  GetResubmissionTypeListLov() {
    let params = new URLSearchParams();
    params.append("listCode", "RESUBMISSIONTYPE");
    this.claimService
      .getLovType(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ResubmissionTypeList = data;
          this.ClaimEditBo.resubmissionTypeLid = this.ResubmissionTypeList.filter(s => s.lovCode == "ORIGINAL")[0].id
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  //.........GetAllClientDropDown.........
  getClientDropDown() {
    this.TimesheetVservice.GetAllClientDropDown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllClientList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  //........GetAllEmployeesDropdown.........
  getEmployeesDropdown() {
    this.TimesheetVservice.GetAllEmployeesDropdown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllEmployeeList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  backToClaimList() {
    this.EditClaim.isCreate = false;
    this.EditClaimemit.emit(this.EditClaim);
  }

  getClaimEditDetails() {
    let params = new URLSearchParams();
    params.append("ClaimId", this.EditClaim.claimId);
    params.append("ClaimType", this.EditClaim?.claimGridType);
    this.claimEditService
      .getEditClaimDetail(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.ClaimEditBo = data;
          this.client_DOB = data?.client_DOB;
          this.client_DOB =
            this.client_DOB != null &&
              this.client_DOB != "" &&
              this.client_DOB != undefined
              ? this.datepipe.transform(
                this.client_DOB,
                "MM/dd/yyyy"
              )
              : null;
          this.BatchServiceLineList = []
          this.denialList = []
          this.BatchServiceLineList.push(this.ClaimEditBo.claimServiceLine)
          this.denialList = data.claimServiceLine.edI835ClaimAdjustments;
          this.IdDates = data?.idandDates;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  saveEditClaim() {
    this.IsButtonDisable = true;
    this.ClaimEditBo.client_DOB =
      this.client_DOB != null &&
        this.client_DOB != "" &&
        this.client_DOB != undefined
        ? this.global.getDateTimeString(this.client_DOB)
        : null;

    this.ClaimEditBo.claimType = this.EditClaim.claimGridType;
    this.claimEditService
      .saveEditClaim(this.ClaimEditBo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.IsButtonDisable = false;
          this.toastservice.success("Claim updated successfully")
          this.backToClaimList();
        },
        (err: any) => {
          this.IsButtonDisable = false;
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == "DOB") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let datevalue = this.dateservice.inputFeildchangeReturnall(event);
          this.client_DOB = datevalue;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "DOB") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let datevalue = this.dateservice.Datechange(event);
          this.client_DOB = datevalue;
        }
      }
    }
  }

  // ................................................decimalOnly................................................
  decimalOnly(event) {
    if (!(this.global.isdigit(event.key) || event.key == ".")) {
      event.preventDefault();
    }

  }
  //........................... paidChange................................................
  paidChange(event: IMyInputFieldChanged, pc) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      pc.paidDateFormated =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  //.......................onPaiddatechanged...................................................
  onPaiddatechanged(event: IMyDateModel, pc) {
    pc.paidDateFormated = event.formatted;
  }
  //............................EditPaidAmount...............................................................
  editPaidAmount() {
    console.log(this.ClaimEditBo.claimServiceLine, "this.ClaimEditBo.claimServiceLine.paidDate")
    this.ClaimEditBo.claimServiceLine.paidDateFormated = this.datePipe.transform(
      this.ClaimEditBo.claimServiceLine.paidDate,
      "MM/dd/yyyy"
    );
  }
  // ...............................updatePaidAmount...............................
  updatePaidAmount() {
    this.IsButtonDisable = true;
    this.ClaimEditBo.claimServiceLine.paidDate =
      this.ClaimEditBo.claimServiceLine.paidDateFormated != null && this.ClaimEditBo.claimServiceLine.paidDateFormated != ""
        ? this.global.getDateTimeString(this.ClaimEditBo.claimServiceLine.paidDateFormated)
        : null;
    this.ClaimEditBo.claimServiceLine.paidAmount =
      this.ClaimEditBo.claimServiceLine.paidAmount == null || this.ClaimEditBo.claimServiceLine.paidAmount == 0
        ? null
        : parseFloat(this.ClaimEditBo.claimServiceLine.paidAmount.toString());
    this.ClaimEditBo.claimServiceLine.balanceDueAmount = (this.ClaimEditBo.claimServiceLine.paidAmount != null && this.ClaimEditBo.claimServiceLine.totalAmount != null) ? (this.ClaimEditBo.claimServiceLine.totalAmount - this.ClaimEditBo.claimServiceLine.paidAmount) : null;
    let urlcsl = "api/Claims/ManuallyPostPayment";
    this.claimEditService.saveorUpdateFunctionwithResponseTypeJson(this.ClaimEditBo.claimServiceLine, urlcsl)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.IsButtonDisable = false;
          this.toastservice.success("Paid Amount updated successfully!");
          setTimeout(() => {
            this.toastservice.clear();
          }, 5000);
          this.getClaimEditDetails();
          document.getElementById("paidAmountUpdateSModalSpan").click();
        },
        (err: any) => {
          this.IsButtonDisable = false;
          this.toastservice.error(err, "Error");
        }
      );
  }
  //...............................................Update Timesheet................................................
  updateTransaction() {
    console.log(this.openverification, 'open')
    let ids = this.IdDates.map(id => id.id);
    let dates = this.IdDates.map(id => id.date);
    this.timesheetVerificationInput.ids = ids;
    this.timesheetVerificationInput.start = dates[0];
    this.timesheetVerificationInput.end =
      dates[dates?.length - 1];
    this.timesheetVerificationInput.from = "Claim";
    this.timesheetVerificationInput.claimId = this.EditClaim.claimId;
    this.timesheetVerificationInput.claimType = this.EditClaim.claimGridType;
    //document.getElementById("openupdatetimesheet").click();
  }

  //..................... Timesheet Verification..................................................................
  fromtimesheetverification() {
    document.getElementById("openupdatetimesheet").click();
    this.openverification = false;
    this.getClaimEditDetails();
  }
}
